module.exports = __webpack_public_path__ + "img/image-left.47fcd48a.svg";